import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Production stability fix:
    //   • Only auto-logout when an authenticated call returns 401 AND the
    //     caller hasn't explicitly opted out (long uploads, retries, etc.)
    //   • Never auto-logout on /login, /signup, /order/* (public flows).
    //   • Never auto-logout if there's no token to begin with — the page
    //     itself will handle the not-signed-in state.
    //   • Bare network errors (status undefined — DNS / proxy drop / CORS)
    //     are returned as-is so callers can surface a retry toast.
    const status = err?.response?.status;
    const cfg = err?.config || {};
    const path = window.location.pathname;
    const isPublicPath = path.startsWith("/login")
      || path.startsWith("/signup")
      || path.startsWith("/order");
    const hasToken = !!localStorage.getItem("mm_token");
    // iter_PLATFORM_OWNER_TENANT_MANAGEMENT (2026-02-28) — 403 with
    // detail.approval_status means the tenant is not in `approved`
    // state. Persist the payload so /pending-approval can render the
    // right copy, and redirect there instead of the app shell.
    if (status === 403) {
      const detail = err?.response?.data?.detail;
      if (detail && typeof detail === "object" && detail.approval_status) {
        try {
          sessionStorage.setItem("mm_pending_status_payload",
                                    JSON.stringify(detail));
        } catch { /* ignore */ }
        if (path !== "/pending-approval") {
          window.location.href = "/pending-approval";
        }
      }
    }
    if (status === 401 && !cfg.__skipAuthRedirect && hasToken && !isPublicPath) {
      localStorage.removeItem("mm_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
